import _regeneratorRuntime from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.array.push.js";
import router from './router';
import store, { prepareStore } from './store';
import { Message } from 'element-ui';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { getToken } from '@/utils/auth'; // get token from cookie
import getPageTitle from '@/utils/get-page-title';
import { REDIRECTS, setRouterIndex } from '@/router/routerSchema';
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ['/auth']; // no redirect whitelist

router.beforeResolve( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(to, from, next) {
    var currentUser, newRoute;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // start progress bar
          NProgress.start();

          // set page title
          document.title = getPageTitle(to.meta.title);

          // determine whether the user has logged in
          // const hasToken = getToken()

          // store.dispatch('users/getCurrentUser')
          currentUser = store.getters['users/getCurrentUser'];
          if (!currentUser) {
            _context.next = 8;
            break;
          }
          prepareStore();
          if (to.path === '/auth') {
            // if is logged in, redirect to the home page
            next({
              path: '/'
            });
            NProgress.done();
          } else {
            next();
          }
          _context.next = 33;
          break;
        case 8:
          if (/\/auth*/.test(to.path)) {
            _context.next = 32;
            break;
          }
          _context.prev = 9;
          _context.next = 12;
          return store.dispatch('users/getCurrentUser');
        case 12:
          _context.prev = 12;
          _context.next = 15;
          return store.dispatch('users/getUserUxProfile');
        case 15:
          // Redirect to home page related on ux_profile
          console.log("App is", process.env.VUE_APP_APP_ID);
          if (to.path == "/" && process.env.VUE_APP_APP_ID != "rulesup") {
            // let  newRoute = setRouterIndex(REDIRECTS,'CEO')
            // console.log("store.state.users.MY_UX_PROFILE",store.state.users.MY_UX_PROFILE)
            newRoute = setRouterIndex(REDIRECTS, store.state.users.MY_UX_PROFILE);
            router.push(newRoute);
          }
          _context.next = 21;
          break;
        case 19:
          _context.prev = 19;
          _context.t0 = _context["catch"](12);
        case 21:
          prepareStore();
          next();
          _context.next = 30;
          break;
        case 25:
          _context.prev = 25;
          _context.t1 = _context["catch"](9);
          Message.error(_context.t1 || 'Redirecting to login...');
          // next({
          //   name: 'name',
          //   query: {
          //     redirect: to.path
          //   }
          // })
          window.location.href = "".concat(process.env.VUE_APP_BASE_URL, "/login");
          NProgress.done();
        case 30:
          _context.next = 33;
          break;
        case 32:
          next();
        case 33:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[9, 25], [12, 19]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function () {
  // finish progress bar
  NProgress.done();
});